import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../api-client';

interface StartSessionPayload {
  tenantId: string;
  reason: string;
  ticketRef: string;
}

interface StartSessionResponse {
  token: string;
  chatUrl: string;
}

async function startSession(
  payload: StartSessionPayload,
): Promise<StartSessionResponse> {
  const res = await apiFetch('/api/console/impersonation', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Failed to start impersonation session');
  return res.json();
}

export function useStartSession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: startSession,
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ['impersonation-sessions'] }),
  });
}
